export const listThingNames = (includePrototypes: boolean, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.listThingNames(
      includePrototypes,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const listThings = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.listThings(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThing = (thingId: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThing(
      thingId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThingName = (thingId: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThingName(
      thingId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThingIdByName = (thingName: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThingIdByName(
      thingName,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThingByName = (thingName: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThingByName(
      thingName,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThingIdByAlias = (
  aliasType: string,
  aliasName: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThingIdByAlias(
      aliasName,
      aliasType,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadThingByGlobalAlias = (
  aliasType: string,
  aliasName: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.loadThingIdByAlias(
      aliasName,
      aliasType,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const updateThing = (thing: any, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.updateThing(
      thing,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const deleteThing = (
  customer: string,
  application: string,
  thingId: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.thing.deleteThing(
      customer,
      application,
      thingId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}
